export const STORES_URL = '/api/stores'
export const EVENT_SYNC_URL = '/api/events_sync'
export const EVENT_LOGS = '/api/events_logs'
export const MATERIAL_NUMBER_URL = '/api/sku_mapping'
export const PROCESS_ORDERS = '/api/process_orders_for_shop'
export const SHIPPING_MAPPING_URL = '/api/shipping_mapping'
export const DELETE_MATERIAL_NUMBER_URL = '/api/sku_delete'
export const MANUAL_SYNC_EVENT_URL = '/api/sync_manually'
export const GET_UNSYNCED_ORDERS_URL = 'api/unsynced_orders'
export const GET_REDIS_QUEUE = 'api/redis_queue'
export const DELETE_REDIS_QUEUE = 'api/delete_redis_queue/'
export const SYNC_ALL_MISSING_ORDERS_ON_DATE = 'api/sync_all'
